import React, { useEffect, useState } from "react";
import { Modal, Typography, Table, Select, Row, Col } from "antd";
import { platformApi } from "../../../../../api";
import { useBranch } from "../../../../../ContextAPI/branch";

const { Text } = Typography;
const { Option } = Select;

const CountModal = ({ open, close }) => {
  const { selectBranch } = useBranch();
  const [categoryWise, setCategoryWise] = useState([]);
  const [branchWise, setBranchWise] = useState([]);
  const [total, setTotal] = useState();
  const [branch, setBranch] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);

  useEffect(() => {
    if (open) {
      getAllBranch();
      getCountDetails(selectBranch);
      setSelectedBranches(selectBranch.map((b) => b.id));
    }
  }, [open]);

  useEffect(() => {
    if (branchWise.length > 0 && selectedBranches.length > 0) {
      const selectedBranchNames = branch
        .filter((b) => selectedBranches.includes(b.id))
        .map((b) => b.name);

      const selectedTotal = branchWise
        .filter((item) => selectedBranchNames.includes(item.branch_name))
        .reduce((sum, item) => sum + Number(item.count), 0);

      setTotal(selectedTotal);
    } else if (selectedBranches.length === 0) {
      setTotal(0);
    }
  }, [branchWise, selectedBranches, branch]);

  const getAllBranch = () => {
    platformApi.get("/api/user/branch").then((res) => {
      setBranch(res.data.data);
    });
  };

  const getCountDetails = (branches) => {
    const payload =
      branches && branches.length
        ? branches.map((obj) => (typeof obj === "object" ? obj.id : obj))
        : [];
    platformApi
      .post(`api/vehicleInventory/counts`, { branch: payload })
      .then((res) => {
        const data = res.data.response.data;

        setCategoryWise(data.categoryWise || []);
        setBranchWise(data.branchWise || []);
      });
  };

  const columns = [
    {
      title: "Data",
      dataIndex: "main",
      key: "main",
      width: "70%",
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
      width: "30%",
      // align: "right",
    },
  ];

  const categoryData = categoryWise.map((item, idx) => ({
    key: `cat-${idx}`,
    main: item.category,
    count: item.count,
  }));

  const branchData = branchWise.map((item, idx) => ({
    key: `brn-${idx}`,
    main: item.branch_name,
    count: item.count,
  }));

 
  const handleBranchChange = (value) => {
    setSelectedBranches(value);
    const selected = branch.filter((b) => value.includes(b.id));
    getCountDetails(selected);
  };

  return (
    <Modal
      title={<Text strong>Vehicle Count Details</Text>}
      visible={open}
      onCancel={close}
      onOk={close}
      width="40vw"
      okText="Save"
      footer={null}
    >
      <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
        <Col span={12} style={{ textAlign: "left" }}>
          <Text strong>Total: </Text>
          <Text>{total}</Text>
        </Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Select
            mode="multiple"
            allowClear
            style={{ minWidth: 200 }}
            placeholder="Select Branch(es)"
            value={selectedBranches}
            onChange={handleBranchChange}
            optionLabelProp="label"
          >
            {branch.map((b) => (
              <Option key={b.id} value={b.id} label={b.name}>
                {b.name}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <div style={{ marginBottom: 32 }}>
        <Text strong style={{ fontSize: 16 }}>
          Branch Wise
        </Text>
        <Table
          columns={columns}
          dataSource={branchData}
          pagination={false}
          style={{ marginTop: 8 }}
        />
      </div>
      <div style={{ marginBottom: 32 }}>
        <Text strong style={{ fontSize: 16 }}>
          Category Wise
        </Text>
        <Table
          columns={columns}
          dataSource={categoryData}
          pagination={false}
          style={{ marginTop: 8 }}
        />
      </div>
    </Modal>
  );
};

export default CountModal;